<template>
  <div>
    <slot
      :items="items"
      :isLoading="isLoading"
    />
    <!-- pagination -->
    <LlPaginate
      :value="page"
      :page-count="totalPage"
      @input="$_pageClick($event)"
    />
  </div>
</template>
<script>
export default {
  name: "WsDateRange",
  props: {
    //一頁幾筆
    limit: {
      type: Number,
      default: 15,
    },
    //起始日期
    startDate: {
      type: String,
      default: "",
    },
    //結束日期
    endDate: {
      type: String,
      default: "",
    },
    service: {
      type: Function,
      default() {
        return;
      },
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    page: 1, //當前頁數
    items: [],
    isLoading: false,
  }),
  computed: {
    //總天數
    totalDate() {
      if (!this.startDate) {
        return "";
      }
      const startDate = this.$moment(this.startDate);
      const endDate = this.$moment(this.endDate);
      return endDate.diff(startDate, "days") + 1;
    },
    //總頁數
    totalPage() {
      if (!this.totalDate) {
        return 0;
      }
      return Math.ceil(this.totalDate / this.limit);
    },
    //當前頁數開始日期
    ingStartDate() {
      if (!this.startDate) {
        return "";
      }
      const totalDays = this.limit * (this.page - 1);
      return this.$moment(this.startDate)
        .add(totalDays, "days")
        .format("YYYY-MM-DD");
    },
    //當前頁數結束日期
    ingEndDate() {
      if (!this.startDate) {
        return "";
      }
      let totalDays = 1;
      if (this.page === this.totalPage) {
        totalDays = this.totalDate - 1;
      } else {
        totalDays = this.limit * this.page - 1;
      }
      return this.$moment(this.startDate)
        .add(totalDays, "days")
        .format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.$_fetchItems();
  },
  methods: {
    async $_fetchItems() {
      if (this.ingStartDate) {
        this.isLoading = true;
        const params = {
          ...this.params,
          start_time: this.ingStartDate,
          end_time: this.ingEndDate,
        };
        const res = await this.service(params);
        this.items = res.data;
        this.isLoading = false;
      }
    },
    $_pageClick(e) {
      if (this.page === e) return;
      this.page = e;
      this.$emit("page-click", e);
      this.$_fetchItems();
    },
  },
};
</script>